import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

/**
 * Redux Store: Web-App-Subscription
 **/

const initialState = {
  c1Accounts: {
    c1AccountID: '',
    c1AccountsList: [],
    c1TrialExtensionsList: {},
  },
  c1Services: { c1ServicesList: [] },
  c1Token: { token: '', expires: '', userUrn: '', role: '', roleName: '', serviceRoleUrnList: [] },
  c1UserDetails: { name: '', email: '', timezone: '', wsAdminID: '', type: '' },
  c1Common: {
    storeId: 'web-app-subscription',
    locale: 'en',
    theme: { colorMode: 'light', overrides: {} },
  },
};

export function reducer(state = initialState, action) {
  switch (action.type) {
    case 'ADD_LAST_SELECTED_ACCOUNT_ID':
    case 'ADD_ACCOUNT_ID':
      return {
        ...state,
        c1Accounts: {
          ...state.c1Accounts,
          c1AccountID: action.c1AccountID,
        },
      };
    case 'ADD_USER_TYPE':
      return {
        ...state,
        c1UserDetails: {
          ...state.c1UserDetails,
          type: action.userType,
        },
      };
    case 'ADD_USER_INFO': {
      const { name = '', email = '', timezone = '' } = action.userDetails;
      return {
        ...state,
        c1UserDetails: {
          ...state.c1UserDetails,
          name,
          email,
          timezone,
        },
      };
    }
    case 'STORE_ACCOUNTS':
      return {
        ...state,
        c1Accounts: {
          ...state.c1Accounts,
          c1AccountsList: action.storeAccounts,
        },
      };
    case 'STORE_INIT':
      // rehydrate the states base on shell state (e.g. upon refresh)
      return {
        ...action.shellInitState,
        c1Common: {
          ...action.shellInitState.c1Common,
          storeId: 'web-app-subscription',
        },
      };
    case 'SET_LOCALE':
      return {
        ...state,
        c1Common: {
          ...state.c1Common,
          locale: action.locale,
        },
      };
    case 'STORE_SERVICES':
      return {
        ...state,
        c1Services: {
          ...state.c1Services,
          c1ServicesList: action.c1ServicesList,
        },
      };
    case 'STORE_TRIAL_EXTENSIONS':
      return {
        ...state,
        c1Accounts: {
          ...state.c1Accounts,
          c1TrialExtensionsList: action.c1TrialExtensionsList,
        },
      };
    case 'STORE_C1_TOKEN':
      return {
        ...state,
        c1Token: {
          ...action.c1Token,
        },
      };
    case 'SET_THEME':
      return {
        ...state,
        c1Common: {
          ...state.c1Common,
          theme: action.theme,
        },
      };
    case 'SET_COLOR_MODE':
      return {
        ...state,
        c1Common: {
          ...state.c1Common,
          theme: {
            ...state.c1Common.theme,
            colorMode: action.colorMode,
          },
        },
      };
    case 'SET_THEME_OVERRIDES':
      return {
        ...state,
        c1Common: {
          ...state.c1Common,
          theme: {
            ...state.c1Common.theme,
            overrides: action.overrides,
          },
        },
      };
    case 'RESET_STORE':
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
}

export const getTokenInfo = (state, type) => state?.c1Token?.[type];
export const getCurrentAccountID = (state) => state?.c1Accounts?.c1AccountID;
export const getCommonType = (state, type) => state?.c1Common?.[type];
export const getTrialExtensions = (state, type) => state?.c1Accounts?.[type];
export const getServices = (state, type) => state?.c1Services?.[type];
export const getUserDetails = (state, type) => state?.c1UserDetails?.[type];
export const getAccountInfo = (state, accountID, key) => {
  const accountInfo = state?.c1Accounts?.c1AccountsList.find((account) => account.id === accountID);
  return accountInfo ? accountInfo[key] : 'Not Available';
};

/**
 * Custom Logger Middleware
 * @param store
 * @returns {function(*): function(*=): *}
 */
/**
 * Logs all actions and states after they are dispatched.
 */
const logger = (store) => (next) => (action) => {
  console.group(action.type, 'web-app-subscription');
  console.debug('web-app-subscription dispatching', action);

  // Call the next dispatch method in the middleware chain
  const result = next(action);

  console.debug('web-app-subscription next state after dispatch', store.getState());
  console.groupEnd();
  return result;
};

const composeEnhancers = composeWithDevTools({ name: 'web-app-subscription' });
export const storeInstance = createStore(reducer, composeEnhancers(applyMiddleware(logger)));
